import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Icon from 'react-bootstrap-icons';

export default function Footer () {
    return (
        <div id='contact-us' className='footer-div drk'>
         <div className='container small-device'>
            <div>
               <Row>                          
                    <Col sm={3} className='footer-text'>
                        <p className='body-text footer-title'>Business Hours</p>
                        <Row>
                        <Col sm='auto'>
                            <p className='body-text text-white mb-0'>Monday</p>
                            <p className='body-text text-white mb-0'>Tuesday</p>
                            <p className='body-text text-white mb-0'>Wednesday</p>
                            <p className='body-text text-white mb-0'>Thursday</p>
                            <p className='body-text text-white mb-0'>Friday</p>
                            <p className='body-text text-white mb-0'>Saturday</p>
                            <p className='body-text text-white'>Sunday</p>
                        </Col>
                        <Col sm='auto'>
                            <p className='body-text text-white mb-0'>8am - 4pm</p>
                            <p className='body-text text-white mb-0'>8am - 5pm</p>
                            <p className='body-text text-white mb-0'>8am - 5pm</p>
                            <p className='body-text text-white mb-0'>8am - 5pm</p>
                            <p className='body-text text-white mb-0'>8am - 5pm</p>
                            <p className='body-text text-white mb-0'>8am - 4pm</p>
                            <p className='body-text text-white'>Closed</p>
                        </Col>
                        </Row>
                    </Col>        
                    <Col sm={3} className='footer-text'>
                        <div className='body-text footer-title'>
                          <img src='./images/map.png' className='footer-map' alt='map'></img>
                        </div>
                    </Col>        
                    <Col sm={3} className='footer-text'>
                        <p className='footer-title'></p>
                        <p className='body-text text-white'>
                            Jalan Sulaiman 3, Taman Putra Sulaiman, 68000 Ampang, Selangor
                        </p>
                        <p className='body-text text-white footer-caption'>+60 (0)3 4260-1198</p>
                        <br />
                        <a href='https://twitter.com/' className='footer-links'><Icon.TwitterX /></a>
                        <a href='https://instagram.com/' className='footer-links'><Icon.Instagram /></a>
                        <a href='https://facebook.com/' className='footer-links'><Icon.Facebook /></a>
                    </Col>        
                    <Col sm={3} className='footer-text'>
                        <p className='body-text footer-title'>Subscribe to our Newsletter !</p>
                        <input type='text' className='form-control footer-form mb-3' placeholder='Name' aria-label='name'></input>
                        <input type='email' className='form-control footer-form mb-3' placeholder='Email' aria-label='email'></input>
                        <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                            <button type='button' className='btn login'>Submit</button>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
    );
}